module.exports = __webpack_public_path__ + "static/media/1.8729211c.jpg";